import { DestroyRef, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TableColumn } from '../../../../@vex/interfaces/table-column.interface';
import { RealEstate, RealEstateService } from '@eadsysteme/ewsrealestateclient-v2';
import { RealEstateTableEntity } from '../models/real-estate-table.model';
import { RealEstateViewStrategy, ViewType } from './real-estate-view.strategy';
import { SessionService } from '../../../services/session.service';
import { MatTableDataSource } from '@angular/material/table';

@Injectable()
export class MainViewStrategy implements RealEstateViewStrategy {
	readonly viewType = ViewType.MAIN;
	readonly menuName = 'REALESTATE';

	private readonly realEstateService = inject(RealEstateService);
	private readonly sessionService = inject(SessionService);

	getColumns(baseColumns: TableColumn<RealEstate>[], translate: (key: string) => string): TableColumn<RealEstate>[] {
		return [...baseColumns];
	}

	enrichRowData(dataSource: MatTableDataSource<RealEstateTableEntity>, destroyRef: DestroyRef): void {
		/* in MainView there is no data to enrich*/
	}

	onRowClick(row: RealEstateTableEntity, router: Router): void {
		router.navigate(['realestates/' + row.realEstateId]);
	}
}
